export function patchUrlProtocol(url, defaultProtocal = 'https') {
  const pattern = /^https?:/gi
  if (!pattern.test(url)) {
    return defaultProtocal + '://' + url
  }
  return url
}
